import create from './create';
import dashboard from './dashboard';
import edit from './edit';
import jobCard from './jobCard';
import jobDetail from './jobDetail';
import JobType from './JobType';
import Priority from './Priority';
import Status from './Status';

const career = {
  create,
  dashboard,
  edit,
  jobCard,
  jobDetail,
  JobType,
  Priority,
  Status,
};

export default career;
